// hooks/useTranscriptomeInfoSettings.js
import { useState, useCallback } from "react";

const defaultSettings = {
  plotType: "nuc_comp_single",
  gcLocation: "all",
  orfType: "uorf",
  min_limit_anchor: "tx_start",
  min_limit_val: 0,
  max_limit_anchor: "tx_end",
  max_limit_val: 0,
  customTranInput: "",
  singleNucTran: "",
  principal: true,
  transcriptInput: "prin_trans",
};

export const useTranscriptomeInfoSettings = () => {
  const [settings, setSettings] = useState(defaultSettings);

  const updateSetting = useCallback((key, value) => {
    setSettings((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  // ✅ Added updateMultipleSettings for short code loading
  const updateMultipleSettings = useCallback((newSettings) => {
    setSettings((prev) => ({
      ...prev,
      ...newSettings,
    }));
  }, []);

  const resetSettings = useCallback(() => {
    setSettings(defaultSettings);
  }, []);

  const validateSettings = useCallback(() => {
    const errors = [];

    if (!settings.plotType) {
      errors.push("Please select a plot type");
    }

    if (
      settings.plotType === "nuc_comp_single" &&
      !settings.singleNucTran.trim()
    ) {
      errors.push(
        "Please enter a transcript ID for single nucleotide composition"
      );
    }

    if (settings.plotType === "orfstats" && !settings.orfType) {
      errors.push("Please select an ORF type for ORF table");
    }

    return {
      isValid: errors.length === 0,
      errors,
    };
  }, [settings]);

  return {
    settings,
    updateSetting,
    updateMultipleSettings,
    resetSettings,
    validateSettings,
  };
};
